###*
@ngdoc service
@name kareo.ui.shared.assets:WebTrackingProvider
@description

Use `WebTrackingProvider` to change the default behavior of the {@link kareo.ui.shared.assets:WebTracking WebTracking} service.
*###


###*
@ngdoc service
@name kareo.ui.shared.assets:WebTracking
@kind function
@description
WebTracking is used to track analytics

The general usage is as follows:

        WebTracking.track(event, properties);
*###

module.exports = angular.module("kareo.ui.shared.modules.analytics", [
  'kareo.ui.shared.modules.analytics.environment',
  'kareo.ui.shared.modules.data'
])
.provider 'WebTracking',
  [->

    ###*

    @ngdoc
    @name #getAnalytics
    @methodOf kareo.ui.shared.assets:WebTrackingProvider
    @description
    Allow overriding the underlying analytics service.  Used for mocks
    ## Usage
    ```js
    WebTrackingProvider.getAnalytics = function(){
     //empty implementation
     return {
        load: functon(){},
        track: functon(){},
        trackLink: functon(){},
        identify: functon(){}
     };
    }
    ```

    *###
    @getAnalytics = () ->
      `window.analytics = window.analytics || [], window.analytics.methods = [
        "identify",
        "group",
        "track",
        "page",
        "pageview",
        "alias",
        "ready",
        "on",
        "once",
        "off",
        "trackLink",
        "trackForm",
        "trackClick",
        "trackSubmit"], window.analytics.factory = function (t) {
        return function () {
          var a = Array.prototype.slice.call(arguments);
          return a.unshift(t), window.analytics.push(a), window.analytics
        }
      };
      for (var i = 0; i < window.analytics.methods.length; i++) {
        var key = window.analytics.methods[i];
        window.analytics[key] = window.analytics.factory(key)
      }
      window.analytics.load = function (t) {
        if (!document.getElementById("analytics-js")) {
          var a = document.createElement("script");
          a.type = "text/javascript", a.id = "analytics-js", a.async = !0, a.src = ("https:" === document.location.protocol ? "https://" : "http://") + "cdn.segment.io/analytics.js/v1/" + t + "/analytics.min.js";
          var n = document.getElementsByTagName("script")[0];
          n.parentNode.insertBefore(a, n)
        }
      }, window.analytics.SNIPPET_VERSION = "2.0.9"`
      return window.analytics

    @$get = ['ANALYTICS_KEY', 'authenticatedUser', (ANALYTICS_KEY, authenticatedUser) ->
      analytics = @getAnalytics()

      analytics.load(ANALYTICS_KEY);

      if(!@isMock)
        authenticatedUser.get().then (user) ->
          UserRoles = []
          user.roles.forEach (role) ->
             UserRoles.push role.name
          analytics.identify(user.email, { roles: UserRoles, email: user.email })

      ###*
      @ngdoc
      @name #track
      @methodOf kareo.ui.shared.assets:WebTracking
      @description
      Track an event and its properties

      @param {string} event name
      @param {Object=} properties Optional properties object
      *###
      track = (description, properties) ->
        analytics.track(description, properties || {})

      service = {
        track: track
        trackLink: (element, description, properties) ->
          analytics.trackLink(element, description, properties || {})
      }

      service
    ]
    return
  ]